export enum TypeProductEnum {
  DRY_FOOD = 1,
  COOKIE = 2,
  WET_FOOD = 3
}
